var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "py-6 px-6 bg-pure-white rounded-xl",
      style: { height: "10.25rem", width: "51.25rem" }
    },
    [
      _c(
        "div",
        { staticClass: "mb-5 flex items-center justify-between" },
        [
          _vm.searchParams["branch"]
            ? _c("BlTextTitle4", {
                staticClass: "text-slate-900",
                attrs: { text: "Current total active client" }
              })
            : _c("BlTextTitle4", {
                staticClass: "text-slate-900",
                attrs: { text: "Current total active client and team members" }
              })
        ],
        1
      ),
      _vm._v(" "),
      _vm.fetchLoading
        ? _c("div", { staticClass: "h-16 grid place-content-center" }, [
            _c("div", { staticClass: "blum-loader-sm" })
          ])
        : !_vm.graphData
        ? _c(
            "div",
            { staticClass: "h-16 grid place-content-center" },
            [_c("BlTextBody2", { attrs: { text: "Data not found." } })],
            1
          )
        : _vm.overviewData.length
        ? _c(
            "div",
            { staticClass: "flex gap-7" },
            _vm._l(_vm.overviewData, function(item) {
              return _c(
                "div",
                {
                  key: item.label,
                  staticClass: "relative h-16 flex items-center",
                  style: {
                    width:
                      "calc((100% - " +
                      (_vm.overviewData.length - 1) * 1.75 +
                      "rem) / " +
                      _vm.overviewData.length +
                      ")"
                  }
                },
                [
                  _c(
                    "BlTooltip",
                    {
                      staticClass: "w-full flex flex-col",
                      attrs: {
                        tooltip:
                          "<div class='min-w-32'>" + item.label + "</div>"
                      }
                    },
                    [
                      _c("BlTextTitle3", {
                        staticClass: "text-slate-900 self-center",
                        attrs: { text: item.value }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "text-center truncate" },
                        [
                          _c("BlTextBody2", {
                            staticClass: "truncate",
                            attrs: { text: item.label }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  item.divider
                    ? _c("div", { staticClass: "absolute -right-3.5" }, [
                        _c("div", {
                          staticClass: "h-13.5 w-0.5 flex-shrink-0 bg-slate-300"
                        })
                      ])
                    : _vm._e()
                ],
                1
              )
            }),
            0
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-400f7350", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-400f7350","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/analytics/mainDashboard/CurrentTotal.vue
// module id = null
// module chunks = 